declare const __OMNI_VERSION__: string;
declare const __OMNI_BUILD__: string;

/** Set at build time (vite.config.ts): semver + build number. */
export const APP_VERSION = __OMNI_VERSION__;
export const APP_BUILD = __OMNI_BUILD__;
export const versionLabel = () => (APP_BUILD && APP_BUILD !== "0" ? `${APP_VERSION} (build ${APP_BUILD})` : APP_VERSION);
